import { deriveAll, randomPrivKey } from './crypto.js';
import { fetchAccountInfo } from './xrpl-api.js';

export async function spin({ fetchAccountInfoImpl = fetchAccountInfo } = {}) {
  const privKey = randomPrivKey();
  const derived = deriveAll(privKey);
  const account = await fetchAccountInfoImpl(derived.classicAddress);

  return {
    win: account.active,
    privateKeyHex: derived.privateKeyHex,
    publicKeyHex: derived.publicKeyHex,
    classicAddress: derived.classicAddress,
    balanceDrops: account.balanceDrops,
    ledgerIndex: account.ledgerIndex,
  };
}
